import React from 'react';
import TextField from '@mui/material/TextField';

export type P_NumberInputForm = P_NumberInputFormBase & {
	id: string;
	label: string;
	shrink: boolean;
	inputStep: number;
};
export type P_NumberInputFormBase = {
	value: number;
	onChange: (value: number) => any;
};
export default function NumberInputForm(props: P_NumberInputForm) {
	const _onChange = React.useCallback(
		(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
			props.onChange(Number(e.target.value)),
		[],
	);
	return (
		<TextField
			id={props.id}
			label={props.label}
			type={'number'}
			InputLabelProps={{
				shrink: props.shrink,
			}}
			size='small'
			value={props.value}
			onChange={_onChange}
			inputProps={{
				step: props.inputStep,
				min: 0,
				max: 99999,
				type: 'number',
			}}
		/>
	);
}
